import './App.css';
import Cards from './components/Cards';
import Social from './components/Social';


function App() {
  return (
    <div className="App">
      <h1>Memory Card Game with React</h1>
      <Cards/>
      <Social/>
    </div>
  );
}

export default App;
